import jwt_decode from "jwt-decode";

export function getToken(){
  return localStorage.getItem("pepcoAccessToken")
}
export function setToken(token){
  if(token==undefined || token==null || token=="")
  return;
  localStorage.setItem("pepcoAccessToken",token)
}
export function removeToken(){
  return localStorage.removeItem('pepcoAccessToken')
}
export function parseToken(){
  var token = localStorage.getItem("pepcoAccessToken");
  if(!token) return ''
  try {
    var user = jwt_decode(token.replace("pepco ",""))
    return JSON.parse(user.user).username
  } catch(e) {
    console.warn('parseToken 解析失败:', e.message || e)
    return ''
  }
}